import { useEffect, useMemo } from 'react';
import { LibraryModel } from '../models/LibraryModel';

/**
 * The Library's model for the signed-in user in the active organisation.
 *
 * It lives for the session, so the page restores the tab, filters, view and
 * search on return. It's rebuilt when the user or the active organisation
 * changes: an org switch and a logout don't reload the app, and one org's
 * documents must never show in another's once the API fills the model. A
 * replaced model stops its upload timer rather than ticking on unseen.
 */
export const useLibraryModel = (me) => {
  const scope = me ? `${me.id}:${me.org_id}` : null;
  // eslint-disable-next-line react-hooks/exhaustive-deps -- rebuilt per scope on purpose
  const model = useMemo(() => new LibraryModel(), [scope]);
  useEffect(() => () => model.stopUploads(), [model]);
  return model;
};
